export interface PartialPaymentPolicy {
  enabled: boolean;
  use_site_defaults?: boolean;
  min_type: 'percent' | 'amount';
  min_percent: number | null;
  min_amount: number | null;
  max_balance_splits: number;
  late_fee_by_split_count?: Record<string, number>;
  /** Taksit (vade) sayısına göre izin verilen ödeme tarihi aralığı */
  due_date_window_by_split_count?: Record<string, { start: string; end: string }>;
  full_payment_days_before_departure: number;
  currency_code?: string | null;
  currency_symbol?: string | null;
}

export interface PartialPaymentBounds {
  min_amount: number;
  max_amount: number;
}

export interface PartialPaymentCardStorage {
  enabled: boolean;
  module_key?: string;
}

export interface PartialPaymentPolicyResponse {
  product_id: number;
  policy: PartialPaymentPolicy;
  bounds?: PartialPaymentBounds;
  card_storage?: PartialPaymentCardStorage;
}

export interface PartialPaymentContext {
  enabled: boolean;
  policy?: PartialPaymentPolicy;
  bounds?: PartialPaymentBounds;
  /** Faz 8: link query veya fatura metadata ile gelen önerilen tutar */
  suggested_pay_amount?: number;
  card_storage?: PartialPaymentCardStorage;
}

export function computePartialPaymentBounds(
  policy: PartialPaymentPolicy,
  totalAmount: number,
): PartialPaymentBounds {
  const total = Math.max(0, Math.round(totalAmount * 100) / 100);
  let min = 0;
  if (policy.min_type === 'amount') {
    min = Number(policy.min_amount ?? 0);
  } else {
    min = total * (Number(policy.min_percent ?? 0) / 100);
  }
  min = Math.min(total, Math.max(0, Math.round(min * 100) / 100));
  return { min_amount: min, max_amount: total };
}
